export class RemoveFilterFailureAction {
    public static readonly type = '[JobsPlacements] Remove filter failure';
}
